module.exports = __webpack_public_path__ + "img/logo-white.7e8f2fdd.svg";